var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_729_4869)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 39.9667,
    height: 39.9667,
    rx: 8,
    fill: "#BEF183"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_4869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8543 23.1222L25.7226 31.2539C24.1598 32.8166 21.6284 32.8166 20.0657 31.2539C18.503 29.6912 18.503 27.1598 20.0657 25.5971L28.9045 16.7582C29.8803 15.7824 31.4643 15.7824 32.4401 16.7582C33.4159 17.734 33.4159 19.318 32.4401 20.2938L25.0154 27.7184C24.6265 28.1073 23.9901 28.1073 23.6012 27.7184C23.2123 27.3295 23.2123 26.6931 23.6012 26.3042L30.3187 19.5867L29.2581 18.526L22.5406 25.2435C21.5648 26.2193 21.5648 27.8032 22.5406 28.779C23.5164 29.7549 25.1003 29.7549 26.0761 28.779L33.5007 21.3544C35.0634 19.7917 35.0634 17.2603 33.5007 15.6976C31.938 14.1349 29.4066 14.1349 27.8439 15.6976L19.005 24.5364C16.8554 26.686 16.8554 30.165 19.005 32.3146C21.1546 34.4642 24.6336 34.4642 26.7832 32.3146L34.9149 24.1828L33.8543 23.1222Z",
    fill: "#0B7340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_729_4869",
    x: 0,
    y: 0,
    width: 51.9667,
    height: 51.9668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_729_4869"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_729_4869"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_729_4869",
    result: "effect2_dropShadow_729_4869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_729_4869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_4869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(26.7832 7.56543) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttached);
export default __webpack_public_path__ + "static/media/file-attached.3862e56cd626591fa7ea8900cea691a2.svg";
export { ForwardRef as ReactComponent };